import React from "react";
import ButtonComponent from "../button/ButtonComponent";
import {ImageConfig} from "../../../constants";
import './AttachmentCardComponent.scss'

interface AttachmentCardProps {
    title?: string;
    onView?: () => void;
}

const AttachmentCard = (props: AttachmentCardProps) => {

    const {title, onView} = props;
    return (
        <div className="attachment-card">
            <div className="attachment-left">
                <div className="attachment-icon">
                    <ImageConfig.ClipIcon/>
                </div>
                <span className="attachment-title">{title}</span>
            </div>

            <ButtonComponent color={'accent'} size={'small'} prefixIcon={<ImageConfig.EyeIcon/>} disabled={true} className="view-button"
                             onClick={onView}>
                View PDF
            </ButtonComponent>
        </div>
    );
};

export default AttachmentCard;
